import { cacheRequests } from "../../utils/cacheRequests";
import { GetOnPremOrderDetailsRequest } from "./on-prem-order/GetOnPremOrderDetailsRequest";
import { GetOnPremOrderDetailsResponse } from "./on-prem-order/GetOnPremOrderDetailsResponse";
import { useOnPremOrdersApi } from "./useOnPremOrdersApi";

const getOnPremOrderDetailsCache = cacheRequests<GetOnPremOrderDetailsResponse>();

export const useCachedOnPremOrdersApi = () => {
    const { getOnPremOrderDetails } = useOnPremOrdersApi();

    const ttlMs = 20000;

    const getCachedOnPremOrderDetails = async (
        request: GetOnPremOrderDetailsRequest
    ): Promise<GetOnPremOrderDetailsResponse> => {
        return getOnPremOrderDetailsCache.getRequest({
            requestFn: () => getOnPremOrderDetails(request),
            key: `on-prem-order-details-${request.orderId}`,
            ttlMs
        });
    };

    return {
        getOnPremOrderDetails: getCachedOnPremOrderDetails
    };
};
